<template>
  <button @click="newChat" class="chat-modal-footer-button"><span>New Conversation</span></button>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState(['user'])
  },
  methods: {
    ...mapMutations(['openMessage']),
    ...mapActions('messageList', ['initMessage']),
    newChat() {
      this.initMessage({ admin: {}, list: []})
      this.openMessage()
    }
  }
}
</script>


<style lang="scss" scoped>
.chat-modal-footer-button { position: absolute; bottom: 30px; left: 50%; height: 45px; padding-left: 20px; padding-right: 20px;
    color: #fff; font-size: 13px; line-height: 46px; pointer-events: auto; cursor: pointer; box-shadow: 0 4px 12px rgba(0,0,0,.1);
    border-radius: 40px; background-color: #7f90a5; text-align: center; border: none; outline: none;
    transition: all .12s; transform: translateX(-50%);
    span { background: url('../assets/new-conversation.png') no-repeat; background-position: 0; background-size: 15px 14px;
    padding-left: 24px; white-space: nowrap; font-weight: 700;
    }
    &:hover {box-shadow: 0 8px 24px rgba(0,0,0,.2);}
}
</style>


// WEBPACK FOOTER //
// src/components/NewChat.vue